module.exports = __webpack_public_path__ + "img/bg_wasteland_view.00169c8e.jpg";